/* src/app/ai-sourcing/exploring-evaluation-criteria/exploring-evaluation-criteria.component.scss */
.exploring-evolution-criteria-card {
  border-radius: 12px;
  border: 3px solid #FFFFFF;
  background:
    linear-gradient(
      183.08deg,
      rgba(163, 255, 226, 0.45) -58.69%,
      rgba(255, 255, 250, 0.45) 53.16%,
      rgba(255, 245, 134, 0.45) 164.33%);
  width: 100%;
  height: auto;
  padding: 20px;
}
.exploring-evolution-criteria-card .evaluation-card-header {
  font-size: 20px;
  font-weight: 600;
  color: #2E93A1;
  line-height: 1;
  margin-bottom: 20px;
  display: flex;
}
.exploring-evolution-criteria-card .evaluation-card-header span {
  font-size: 21px;
  margin-right: 10px;
}
.exploring-evolution-criteria-card .evaluation-card-header p {
  margin-bottom: 0;
}
.exploring-evolution-criteria-card .evaluation-subheader {
  font-size: 12px;
  line-height: 1.7;
  margin-bottom: 20px;
}
.exploring-evolution-criteria-card .evaluation-middle-content {
  margin-bottom: 20px;
}
.exploring-evolution-criteria-card .evaluation-middle-content p {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.7;
  margin-bottom: 15px;
}
.exploring-evolution-criteria-card .evaluation-middle-content ol {
  padding-left: 17px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.7;
  color: #484b59;
}
.exploring-evolution-criteria-card .evaluation-middle-content ol li {
  padding-left: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.7;
  color: #484b59;
  margin-bottom: 5px;
}
.exploring-evolution-criteria-card .evaluation-middle-content ol li span {
  font-weight: 500;
}
.exploring-evolution-criteria-card .evaluation-footer h3 {
  font-size: 12px;
  line-height: 1.7;
  font-weight: 600;
  color: #484b59;
  margin-bottom: 10px;
}
.exploring-evolution-criteria-card .evaluation-footer .example-list {
  margin-bottom: 10px;
}
.exploring-evolution-criteria-card .evaluation-footer .example-list p.warnign-icon {
  color: #C97272;
  font-size: 10px;
  line-height: 1.7;
  margin-bottom: 3px;
}
.exploring-evolution-criteria-card .evaluation-footer .example-list p.warnign-icon i {
  color: #C97272;
  font-size: 10px;
}
.exploring-evolution-criteria-card .evaluation-footer .example-list p.green-check {
  color: #2AB700;
  font-size: 10px;
  line-height: 1.7;
  margin-bottom: 3px;
}
.exploring-evolution-criteria-card .evaluation-footer .example-list p.green-check i {
  color: #2AB700;
  font-size: 10px;
}
/*# sourceMappingURL=exploring-evaluation-criteria.component-D4YRKFDT.css.map */
